import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { beaconSelector } from '../recoil/selector';
import useNav from '../hooks/useNav';
import { useEffect, useState } from 'react';
import useBeacon from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';
import { JOB_TYP } from '../types/types';
import { useLocation, useParams } from 'react-router-dom';
import { validateNumString, validateYearMonth } from '../helper/validator';
import useScrapNhisFullsheet from '../hooks/useScrapNhisFullsheet';
import useCompanySearch from '../hooks/useCompanySearch';
import useToast from '../hooks/useToast';
import useBlocker from '../hooks/useBlocker';
import { isIOS } from 'react-device-detect';

const useStep3 = () => {
  const { media } = useParams();
  const location = useLocation();
  const props = location?.state;
  const { navigate, routerNavigate } = useNav();
  const { addToast } = useToast();

  //
  // beacon
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.CONDITIONS_STEP3,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const sendBeaconClkBtnInputBiz = (btnNm: string) => {
    const temp = {
      job: jobTyp?.text ?? '',
      job_type:
        inputForms?.employeeTyp?.text ?? inputForms?.businessTyp?.text ?? '',
      co_name: inputForms?.compNm ?? '',
      join_date: inputForms?.joinDt ?? '',
      income: inputForms?.salaryAmt ?? '',
    };
    beacon.sendClkBtnInputBiz({
      properties: { btnNm, ...temp },
    });
  };

  const isUseSMSCert = () => {
    // return (media === "lgu" && isIOS);
    return false;
  };

  const [shouldBlock, setShouldBlock] = useState<any>(true);
  //
  useBlocker((tx: any) => {
    if (tx.action === 'POP') {
      setPopup((prev) => ({
        ...prev,
        message: '심사 신청이 완료되지 않았습니다.\n 그래도 나가시겠습니까?',
        open: true,
        cancelText: '예',
        onClickCancel: () => {
          setShouldBlock(false);
          setPopup((prev) => ({ ...prev, open: false }));
          routerNavigate(isUseSMSCert() ? -2 : -1);
        },
        confirmText: '아니요',
        onClickConfirm: () => {
          setPopup((prev) => ({ ...prev, open: false }));
        },
      }));
    } else {
      tx.retry();
    }
  }, shouldBlock);

  //
  // 회사정보 bottomSheet
  const {
    isOpenSearchBottomsheet,
    openSearchBottomsheet,
    closeSearchBottomsheet,
    isOpenInBizBottomsheet,
    openInBizBottomsheet,
    closeInBizBottomsheet,
    closeSearchAndInBizBottomsheet,
    searchCompany,
  } = useCompanySearch();

  // feat: KT 건강보험공단 스크래핑 기능 제거 여기서만 undefined 처리
  let scrapNhisFullsheet: undefined | any = undefined;
  //     useScrapNhisFullsheet(
  //   media ?? '',
  //   'initial',
  //   () => {
  //     addToast('전자증명서를 불러오려면 직업 선택을 다시해주세요');
  //     if (autoFocus && !inputForms?.compNm) {
  //       openSearchBottomsheet();
  //     }
  //   },
  // );

  const closePopupScrapNhisFullsheet = () => {
    if (!scrapNhisFullsheet) return;
    if (scrapNhisFullsheet.state === 'loading') {
      setPopup((prev) => ({
        ...prev,
        open: true,
        message: '고객님의 정보를 직접 입력하시겠습니까?',
        cancelText: '예',
        onClickCancel: () => {
          setPopup((prev) => ({ ...prev, open: false }));
          scrapNhisFullsheet.close();
        },
        confirmText: '아니요',
        onClickConfirm: () => {
          setPopup((prev) => ({ ...prev, open: false }));
        },
      }));
    } else {
      scrapNhisFullsheet.close();
    }
  };

  // popup
  const [popup, setPopup] = useState({
    message:
      '인증서를 불러오는 중 나갈 경우\n' +
      '정보를 직접 입력해야 합니다.\n' +
      '그래도 나가시겠습니까?',
    open: false,
    cancelText: '예',
    onClickCancel: () => {
      setShouldBlock(false);
      setPopup((prev) => ({ ...prev, open: false }));
      routerNavigate(-1);
    },
    confirmText: '아니요',
    onClickConfirm: () => {
      setPopup((prev) => ({ ...prev, open: false }));
    },
  });

  useEffect(() => {
    if (scrapNhisFullsheet && scrapNhisFullsheet?.scrapData) {
      const { scrapData } = scrapNhisFullsheet ?? {};
      setInputForms((prev: any) => ({
        ...prev,
        compNm: scrapData?.compNm ?? '',
        compRegNo: scrapData?.compRegNo ?? '',
        joinDt: scrapData?.joinDt?.replace('.', '') ?? '',
        salaryAmt: scrapData?.salaryAmt ? String(scrapData?.salaryAmt) : '',
      }));

      setPersonal((prev: any) => {
        return {
          ...prev,
          ...inputForms,
          jobTyp,
          compNm: scrapData?.compNm ?? '',
          compRegNo: scrapData?.compRegNo ?? '',
          joinDt: scrapData?.joinDt?.replace('.', '') ?? '',
          salaryAmt: scrapData?.salaryAmt ? String(scrapData?.salaryAmt) : '',
          scrapingYn: 'Y',
        };
      });

      navigateNextStep();
    }
  }, [scrapNhisFullsheet?.scrapData]);

  //
  //
  const [personal, setPersonal] = useRecoilState(Atom.personalInfo);
  const [jobTyp, setJobTyp] = useState<any>(personal.jobTyp);

  const [ctgGrpList] = useRecoilState(Atom.commonCodes);
  const income = ctgGrpList[1].list.map((item: any) => {
    let temp;
    if (item.codeNm === '기타') {
      temp = '기타';
    } else if (item.codeNm === '무직') {
      temp = '무직';
    } else if (item.codeNm === '전문직') {
      temp = '전문직';
    } else {
      temp = item.codeNm;
    }
    return { text: temp, value: item.code };
  });
  const employee = ctgGrpList[2].list.map((item: any) => {
    return { text: item.codeNm, value: item.code };
  });
  const business = ctgGrpList[4].list.map((item: any) => {
    return { text: item.codeNm, value: item.code };
  });

  //
  //
  const [inputForms, setInputForms] = useState<any>({});
  const [joinDtText, setJoinDtText] = useState<string>('');
  const [warningJoinDtText, setWarningJoinDtText] = useState<string>('');
  const [warningSalaryText, setWarningSalaryText] = useState<string>('');
  const [isActive, setIsActive] = useState<boolean>(false);
  const [autoFocus, setAutoFocus] = useState(true);
  const [selectSheet, setSelectSheet] = useState<any>({
    open: false,
    title: '',
    onClose: () => {},
    onChange: () => {},
    onConfirm: () => {},
    items: [],
    defaultValue: {},
  });
  const [dirtyJobTyp, setDirtyJobTyp] = useState<boolean>(false);

  const type: any = {
    jobTyp: {
      title: '직업',
      onChange: (v: any) => onClickJobType(v),
      onConfirm: (v: any) => onClickJobType(v),
      items: income,
      defaultValue: jobTyp,
    },
    employeeTyp: {
      title: '고용형태',
      onChange: (v: any) => onClickEmployeeTyp(v),
      onConfirm: (v: any) => onClickEmployeeTyp(v),
      items: employee,
      defaultValue: inputForms?.employeeTyp,
    },
    businessTyp: {
      title: '업종',
      onChange: (v: any) => onClickBusinessTyp(v),
      onConfirm: (v: any) => onClickBusinessTyp(v),
      items: business,
      defaultValue: inputForms?.businessTyp,
    },
  };

  // 직업에 따라 정보입력필드 세팅
  const initInputForms = () => {
    setJoinDtText(personal.joinDt ?? '');
    if (jobTyp.value === JOB_TYP.IN_OCCUPATION) {
      setInputForms({
        salaryAmt: personal?.salaryAmt ?? '',
      });
    } else if (jobTyp.value === JOB_TYP.FREELANCER) {
      setInputForms({
        joinDt: personal?.joinDt ?? '',
        salaryAmt: personal?.salaryAmt ?? '',
      });
    } else if (jobTyp.value === JOB_TYP.BUSINESS_MAN) {
      setInputForms({
        businessTyp: personal?.businessTyp ?? {},
        compNm: personal?.compNm ?? '',
        compRegNo: personal?.compRegNo ?? '',
        joinDt: personal?.joinDt ?? '',
        salaryAmt: personal?.salaryAmt ?? '',
      });
    } else {
      setInputForms({
        employeeTyp: personal?.employeeTyp ?? {},
        compNm: personal?.compNm ?? '',
        compRegNo: personal?.compRegNo ?? '',
        joinDt: personal?.joinDt ?? '',
        salaryAmt: personal?.salaryAmt ?? '',
      });
    }
  };

  // 클릭한 필드에 대한 selectSheet 세팅
  const onClickOpenSelectSheet = (id: string) => {
    setSelectSheet(() => {
      return {
        open: true,
        title: type[id]?.title,
        onClose: closeSelectSheet,
        onChange: type[id]?.onChange,
        onConfirm: type[id]?.onConfirm,
        items: type[id]?.items,
        defaultValue: type[id]?.defaultValue ?? {},
      };
    });
  };
  const closeSelectSheet = () => {
    setSelectSheet((prev: any) => {
      return { ...prev, open: false };
    });
  };

  // selectSheet 내 아이템 클릭
  const onClickJobType = (v: any) => {
    setJobTyp(v);
    closeSelectSheet();
  };
  const onClickEmployeeTyp = (v: any) => {
    setInputForms((prev: any) => {
      return {
        ...prev,
        employeeTyp: v,
      };
    });
    closeSelectSheet();

    if (
      (jobTyp.value === '01' || jobTyp.value === '03') &&
      scrapNhisFullsheet
    ) {
      scrapNhisFullsheet?.open();
    }
  };
  const onClickBusinessTyp = (v: any) => {
    setInputForms((prev: any) => {
      return {
        ...prev,
        businessTyp: v,
      };
    });
    closeSelectSheet();
  };

  const setJoinDt = (v: string) => {
    const date = v.replace('.', '');
    if (date.length > 6) return;
    setJoinDtText(date);
    if (date) {
      const message =
        validateYearMonth({
          year: date.substring(0, 4),
          month: date.substring(4),
        }) && date.length >= 6
          ? ''
          : '입력 날짜를 다시 확인해 주세요';
      setWarningJoinDtText(message);

      if (message === '') {
        setInputForms((prev: any) => {
          return {
            ...prev,
            joinDt: date,
          };
        });
      }
    } else if (date.length < 6 && inputForms.joinDt) {
      setInputForms((prev: any) => {
        return {
          ...prev,
          joinDt: '',
        };
      });
    }
  };
  const setCompanyInfo = (name: string, regNo: string) => {
    setInputForms((prev: any) => {
      return {
        ...prev,
        compNm: name,
        compRegNo: regNo,
      };
    });
  };
  const setCustIncome = (v: string) => {
    if (validateNumString(v)) {
      return setInputForms((prev: any) => {
        return {
          ...prev,
          salaryAmt: v,
        };
      });
    }
  };
  const setPersonalInfo = () => {
    setPersonal((prev: any) => {
      return {
        ...prev,
        ...inputForms,
        scrapingYn: 'N',
        jobTyp,
      };
    });
  };
  const onChangeCustIncome = (value: string) => {
    let amt = value.replace(/,/g, '');
    if (amt.length > 5) return;
    if (isNaN(Number(amt))) return;
    amt = amt.replace(/\./g, '');
    setCustIncome(amt);
  };

  const clearFocus = () => {
    setAutoFocus(false);
  };
  const navigateNextStep = () => {
    navigate('/conditions/5', { state: props });
  };

  useEffect(() => {
    if (parseInt(inputForms.salaryAmt) === 0) {
      setWarningSalaryText('1만 원 이상만 입력할 수 있어요');
    } else {
      setWarningSalaryText('');
    }
  }, [inputForms.salaryAmt]);

  useEffect(() => {
    if (!jobTyp.text) {
      setSelectSheet({
        open: true,
        title: '직업',
        onClose: closeSelectSheet,
        onChange: onClickJobType,
        onConfirm: onClickJobType,
        items: income,
        defaultValue: jobTyp,
      });
    } else {
      initInputForms();
    }
  }, [jobTyp]);

  useEffect(() => {
    if (
      typeof jobTyp === 'object' &&
      Object.keys(jobTyp).length > 0 &&
      !dirtyJobTyp
    ) {
      setDirtyJobTyp(true);
    }
  }, [jobTyp, inputForms]);

  useEffect(() => {
    if (dirtyJobTyp) {
      if (
        ['01', '03'].includes(jobTyp?.value) &&
        typeof inputForms?.employeeTyp === 'object' &&
        Object.keys(inputForms.employeeTyp).length > 0 &&
        scrapNhisFullsheet
      ) {
        addToast('전자증명서를 불러오려면 직업 선택을 다시해주세요');
      }
    }
  }, [dirtyJobTyp]);

  useEffect(() => {
    if (Object.keys(inputForms).length > 0) {
      if (
        Object.values(inputForms).every(
          (item: any) => item !== '' && Object.keys(item).length !== 0,
        ) &&
        inputForms?.salaryAmt > 0
      ) {
        setIsActive(true);
        return;
      } else {
        setIsActive(false);
      }
      if (!autoFocus) return;

      let el: any = Object.entries(inputForms);
      for (let i = 0; i < el.length; i++) {
        if (typeof el[i][1] === 'object' && !Object.keys(el[i][1]).length) {
          setSelectSheet(() => {
            return {
              open: true,
              title: type[el[i][0]]?.title,
              onClose: closeSelectSheet,
              onChange: type[el[i][0]]?.onChange,
              onConfirm: type[el[i][0]]?.onConfirm,
              items: type[el[i][0]]?.items,
              defaultValue: type[el[i][0]]?.defaultValue ?? {},
            };
          });
          break;
        }
        if (typeof el[i][1] === 'string' && !el[i][1]) {
          if (el[i][0] === 'compNm') {
            if (
              !(
                (jobTyp.value === '01' || jobTyp.value === '03') &&
                scrapNhisFullsheet
              )
            ) {
              openSearchBottomsheet();
            }
            break;
          }
        }
        if (el[i][0] === 'joinDt' && el[i][1].length !== 6) {
          document?.getElementById('joinDt')?.focus();
          break;
        } else if (el[i][0] === 'salaryAmt') {
          document?.getElementById('salaryAmt')?.focus();
          break;
        }
      }
    }
  }, [inputForms]);

  return {
    jobTyp,
    isActive,
    warningJoinDtText,
    inputForms,
    selectSheet,
    onClickOpenSelectSheet,
    navigateNextStep,
    warningSalaryText,
    onChangeCustIncome,
    setCompanyInfo,
    setJoinDt,
    setPersonalInfo,
    joinDtText,
    clearFocus,
    sendBeaconClkBtnInputBiz,
    scrapNhisFullsheet,
    closePopupScrapNhisFullsheet,
    //
    isOpenSearchBottomsheet,
    openSearchBottomsheet,
    closeSearchBottomsheet,
    isOpenInBizBottomsheet,
    openInBizBottomsheet,
    closeInBizBottomsheet,
    closeSearchAndInBizBottomsheet,
    searchCompany,
    //
    popup,
    setPopup,
  };
};

export default useStep3;
